import _ from 'underscore';

/**
 * extend the observable for radios
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @returns {undefined} - the function extend passed local directly
 */
export function radios(local, attrs) {
  _.extend(local, {
    radios: attrs.type === 'string' ? local : local.string,
  });
}
